<div
  [attr.isSearchBoxSpinner]="isSearchBoxSpinner"
  class="eb-spinner"
  [style.padding]="padding + 'px'"
  [style.width]="width"
  [style.textAlign]="alignment"
>
  <em class="fas fa-spinner spinner-animation" [class]="'fa-' + size + 'x'"></em>
</div>
